import { TimeSeriesChartDataItem } from 'utils/components/TimeSeriesChart/TimeSeriesChartData';
import { StreamMessage } from 'utils/messages/StreamMessage';

export interface MarketDataBarItem extends TimeSeriesChartDataItem {
    open?: number;
    close?: number;
    high?: number;
    low?: number;
    volume?: number;
}

export interface MarketDataTickItem extends TimeSeriesChartDataItem {
    bid?: number;
    ask?: number;
    lastPrice?: number;
    volume?: number;
    high?: number;
    low?: number;
}

export interface MarketDataBars {
    symbol: string;
    binSize: number;
    bars: MarketDataBarItem[];
    messages: Array<StreamMessage>;
}

export interface MarketDataTickData {
    symbol: string;
    ticks: MarketDataTickItem[];
    messages: Array<StreamMessage>;
}

export interface MarketDataRefData {
    startTradingHoursTimestamp: number;
    endTradingHoursTimestamp: number;
    averageVolume: number;
    pnc: number;
}

export interface MarketDataState {
    messages: Array<StreamMessage>;
    indigoMarketDataEnabled: boolean;
    externalMarketDataSource?: string;
    bars: MarketDataBars[];
    ticks: MarketDataTickData[];
    refData: {
        [symbol: string]: MarketDataRefData;
    };
}

export const initialMarketDataState: MarketDataState = {
    indigoMarketDataEnabled: true,
    bars: [],
    ticks: [],
    refData: {},
    messages: [],
};
